'use client';
import React, { useState } from 'react';
import { toast } from '@/utils/toast';
import { Trash } from '@/components/icons';
import DeleteModal from '@/components/ui/modals/delete-modal';
import { useTranslations } from 'next-intl';
import { deleteUserAddress } from '@/services/user/addresses';

function CardFooter({ id, onDeleteSuccess, mage }) {
  const t = useTranslations();

  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteUserAddress({ mage, id });
      toast.success(t('user.address_delete_success_key'));

      if (onDeleteSuccess) onDeleteSuccess();
    } catch (error) {
      console.error(error);
      toast.error(t('user.address_delete_failed_key'));
    } finally {
      setIsDeleting(false);
      setIsOpen(false);
    }
  };

  return (
    <>
      <div className='flex items-center gap-2'>
        <Trash />
        <button
          onClick={() => setIsOpen(true)}
          className={`text-primary hover:text-primary-dark cursor-pointer underline`}
        >
          {t('common.delete_key')}
        </button>
      </div>
      {isOpen && (
        <DeleteModal
          title={t('user.delete_address_key')}
          message={t('user.delete_message_msg_key')}
          onDelete={handleDelete}
          isDeleting={isDeleting}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}

export default CardFooter;
